import React from "react";
import {Panel, Label, Button, TextBox, ComboBox, CheckBox, Table, Image, Map, Tabset, Splitter} from "lib/components";
import {Tool} from "./Tool";

export const ToolDefs = {
    "pointer": {caption: "Select", onUse: use, type:null},
    "label": {caption: "Label", onUse: use, type:Label},
    "button": {caption: "Button", onUse: use, type: Button},
    "text": {caption: "Text box", onUse: use, type:TextBox},
    "combo": {caption: "Combo box", onUse: use, type:ComboBox},
    "check": {caption: "Check box", onUse: use, type:CheckBox},
    "table": {caption: "Table", onUse: use, type:Table},
    "image": {caption: "Image", onUse: use, type:Image},
    "map": {caption: "Map", onUse: use, type: Map},
    "panel": {caption: "Panel", onUse: use, type:Panel},
    "tabset": {caption: "Tabset", onUse: use, type:Tabset},
    "split": {caption: "Splitter", onUse: use, type:Splitter},
};

export function Tools({selected, setSelected, addComponent, ...props}) {
    let tools = [];
    for (let type in ToolDefs) {
        let def = ToolDefs[type];
        tools.push(<Tool key={type} type={type} caption={def.caption} tool={type} imageProps={def.imageProps} fillRow
            margin={0} onUse={(tool) => def.onUse(tool, addComponent)}
            selected={selected === type} setSelected={setSelected}/>);
    }

    return (
        <Panel {...props} >
            {tools}
        </Panel>
    );
}

function use(tool, addComponent) {
    addComponent(tool);
}
